// Global Instructions Rule Applied!
//
// Phase 2 — original Email Campaigns landing page; Phase 5 splits it into
// two tabs (Drafts + Sent log). 2026-05-29 adds a third Templates tab
// (operator-defined email design templates — the "design once, send N
// times" workflow that complements Stripo-imported one-offs).
//
//   * Drafts (default)   — DraftsTab.tsx
//   * Sent log           — SentLogTab.tsx
//   * Templates          — TemplatesTab.tsx
//
// Each tab owns its own state. The container takes an optional
// initialTab prop so navigation to bare /email-design-templates opens
// the Email page already focused on the Templates tab.

import React, { useState } from 'react'
import { Tabs, Typography } from 'antd'
import DraftsTab from './DraftsTab.tsx'
import SentLogTab from './SentLogTab.tsx'
import TemplatesTab from './TemplatesTab.tsx'

const { Title } = Typography

type TabKey = 'drafts' | 'sent_log' | 'templates'

interface EmailCampaignsPageProps {
  initialTab?: TabKey
}

export default function EmailCampaignsPage({
  initialTab = 'drafts'
}: EmailCampaignsPageProps = {}) {
  const [activeTab, setActiveTab] = useState<TabKey>(initialTab)

  return (
    <div className='h-full overflow-hidden'>
      <div className='w-full h-full flex flex-col bg-white px-2 sm:px-4 py-2 sm:py-4 overflow-hidden'>
        <Title level={4} style={{ margin: 0, marginBottom: 8 }}>
          Send Email
        </Title>
        <Tabs
          activeKey={activeTab}
          onChange={(k) => setActiveTab(k as TabKey)}
          className='flex-1 min-h-0'
          destroyInactiveTabPane={false}
          items={[
            {
              key: 'drafts',
              label: 'Drafts',
              children: <DraftsTab />
            },
            {
              key: 'sent_log',
              label: 'Sent log',
              children: <SentLogTab />
            },
            {
              key: 'templates',
              label: 'Templates',
              children: <TemplatesTab />
            }
          ]}
        />
      </div>
    </div>
  )
}
